import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
  useEffect,
} from "react";
import { aviatorStateType } from "../@types";

const getLocalStorageBoolean = (
  key: string,
  defaultValue: boolean
): boolean => {
  if (typeof window === "undefined") return defaultValue;
  const stored = window.localStorage.getItem(key);
  return stored !== null ? stored === "true" : defaultValue;
};

const initValue: aviatorStateType = {
  token: "",
  socket: null,
  game_anim_status: "WAITING",
  dimension: {
    width: 1920,
    height: 630,
  },
  auth: true,
  balance: 0,
  autoPlayParams: [
    {
      nOfRounds: 0,
      stopIfarr: [0, 0, 0],
    },
    {
      nOfRounds: 0,
      stopIfarr: [0, 0, 0],
    },
  ],
  RemainedAutoPlayCount: [0, 0],
  musicChecked: getLocalStorageBoolean("musicChecked", true),
  fxChecked: getLocalStorageBoolean("fxChecked", true),
  animationChecked: getLocalStorageBoolean("animationChecked", true),
  vol: 50,
};

const AviatorContext = createContext<{
  aviatorState: aviatorStateType;
  setAviatorState: Dispatch<SetStateAction<aviatorStateType>>;
}>({
  aviatorState: initValue,
  setAviatorState: () => {},
});

const AviatorProvider = ({ children }: { children: React.ReactNode }) => {
  const [aviatorState, setAviatorState] = useState<aviatorStateType>(initValue);

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(
      "musicChecked",
      String(aviatorState.musicChecked),
    );
  }, [aviatorState.musicChecked]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.localStorage.setItem("fxChecked", String(aviatorState.fxChecked));
  }, [aviatorState.fxChecked]);

  // ✅ Persist + broadcast animation toggle
  useEffect(() => {
    if (typeof window === "undefined") return;

    window.localStorage.setItem(
      "animationChecked",
      String(aviatorState.animationChecked),
    );

    window.dispatchEvent(
      new CustomEvent("aviator:animation", {
        detail: { animationChecked: aviatorState.animationChecked },
      }),
    );
  }, [aviatorState.animationChecked]);

  return (
    <AviatorContext.Provider value={{ aviatorState, setAviatorState }}>
      {children}
    </AviatorContext.Provider>
  );
};

const useAviator = () => useContext(AviatorContext);

export default AviatorProvider;
export { useAviator };
